import { SampleServiceModelBase } from "./base/sample-service-model-base";

export class ContactSalesSM extends SampleServiceModelBase<number>{
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    contactNumber!: number;
    select: string = '';
    companyName: string = '';
    companySize: string = '';
    product: string = ''
    contactMessage: string = '';
}